import React from 'react';
import { Episode } from '../types/api';
import { useI18n } from '../i18n/I18nContext';

interface Props {
  episodes: Episode[];
  fallbackThumbnail?: string;
  selectedEpisode?: number | null;
  disabled?: boolean;
  onSelect?: (episodeId: number) => void;
}

export const EpisodeList: React.FC<Props> = ({ episodes, fallbackThumbnail, selectedEpisode, disabled, onSelect }) => {
  const { t } = useI18n();
  return (
    <ol aria-label={t('episodes')} tabIndex={0} className="episode-list mt-3 flex gap-3 overflow-x-auto overscroll-x-contain pb-4 pt-1 snap-x snap-proximity focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#ffd460]">
      {episodes.map(episode => {
        const selected = selectedEpisode === episode.id;
        const content = <>
          <div className="aspect-video overflow-hidden bg-stone-800">
            <img src={episode.thumbnailUrl || fallbackThumbnail} alt="" loading="lazy" className="h-full w-full object-cover"
              onError={event => {
                const image = event.currentTarget;
                if (fallbackThumbnail && image.getAttribute('src') !== fallbackThumbnail) image.src = fallbackThumbnail;
                else image.style.visibility = 'hidden';
              }} />
          </div>
          <span className="block p-3 text-sm leading-6 break-words">
            {episode.episodeNumber}. {episode.title} <span className="whitespace-nowrap">({Math.floor(episode.durationSeconds / 60)}:{String(episode.durationSeconds % 60).padStart(2, '0')})</span>
          </span>
        </>;
        const cardClass = `block h-full w-full overflow-hidden rounded-lg border text-left ${selected ? 'border-[#ffd460] text-[#ffd460]' : 'border-stone-700 text-stone-300'}`;
        return <li key={episode.id} className="w-48 shrink-0 snap-start sm:w-56">
          {onSelect ? <button type="button" aria-pressed={selected} disabled={disabled} onClick={() => onSelect(episode.id)}
            className={`${cardClass} transition hover:border-[#ffd460] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#ffd460] disabled:opacity-40`}>{content}</button>
            : <div className={cardClass}>{content}</div>}
        </li>;
      })}
    </ol>
  );
};
